/**
 * useQueryInvalidation — Centralized React Query cache invalidation helpers.
 */
import { useQueryClient } from "@tanstack/react-query";

export const useQueryInvalidation = () => {
  const queryClient = useQueryClient();

const invalidateGoals = async () => {
    await queryClient.invalidateQueries({ 
      queryKey: ["goals"],
      refetchType: 'all',
    });
    
    await queryClient.refetchQueries({ 
      queryKey: ["goals"],
      type: 'all'
    });
  };

  return {
    invalidateGoals
  };
};
